import RequireAuthClick from '../../reusable/RequireAuthClick';

const ReferenceCard = ({
    name,
    title,
    date,
    message,
    photo,
    relationship,
    onProfileClick
}) => {
    return (
        <div className='py-3'>
            <div className='flex border-b pb-5'>
                <RequireAuthClick popupType='profile'>
                    <img
                        onClick={onProfileClick}
                        src={photo || '/images/profile.png'}
                        className='w-[42px] h-[42px] rounded-full'
                    />
                </RequireAuthClick>
                <div className='px-5'>
                    <RequireAuthClick popupType='profile'>
                        <h3
                            onClick={onProfileClick}
                            className='font-bold text-lg'
                        >
                            {name}
                        </h3>
                    </RequireAuthClick>
                    <p>
                        {relationship} / {title}{' '}
                    </p>
                    <p className='text-black text-opacity-40 mb-5'>{date}</p>
                    <p className='font-poppins'>{message}</p>
                </div>
            </div>
        </div>
    );
};

export default ReferenceCard;
